var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecisionmaking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C795D26B-1D67-4D60-842D-B358522DF166") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.0338439,12.9619226 L14.5018406,10.330553 C14.4336777,10.2596824 14.3417646,10.2199196 14.2460515,10.2199196 L10.730792,10.2199196 L10.730792,8.54724753 L15.2188576,8.54724753 C15.4202589,8.54724753 15.5836599,8.37477479 15.5836599,8.16191205 L15.5836599,2.89917277 C15.5836599,2.68631004 15.4202589,2.5138373 15.2188576,2.5138373 L10.730792,2.5138373 L10.730792,0.385335473 C10.730792,0.172472741 10.567391,0 10.3659898,0 L6.77686736,0 C6.5754661,0 6.41206508,0.172472741 6.41206508,0.385335473 L6.41206508,2.5138373 L2.8968056,2.5138373 C2.8010925,2.5138373 2.70917942,2.55360012 2.6410165,2.62447074 L0.109013184,5.25584039 C0.0391877419,5.32834167 0,5.42730967 0,5.53054243 C0,5.63377519 0.0391877419,5.73274321 0.109013184,5.80524446 L2.6410165,8.43661412 C2.70917942,8.50748473 2.8010925,8.54724755 2.8968056,8.54724755 L6.41206508,8.54724755 L6.41206508,10.2199196 L1.92399952,10.2199196 C1.72259826,10.2199196 1.55919724,10.3923923 1.55919724,10.6052551 L1.55919724,15.8679944 C1.55919724,16.0808571 1.72259826,16.2533298 1.92399952,16.2533298 L6.41206508,16.2533298 L6.41206508,18.9003788 C6.41206508,19.1132415 6.5754661,19.2857143 6.77686736,19.2857143 C6.97826862,19.2857143 7.14166964,19.1132415 7.14166964,18.9003788 L7.14166964,16.2533298 L10.0011875,16.2533298 L10.0011875,18.9003788 C10.0011875,19.1132415 10.1645885,19.2857143 10.3659898,19.2857143 C10.567391,19.2857143 10.7307921,19.1132415 10.7307921,18.9003788 L10.7307921,16.2533298 L14.2460515,16.2533298 C14.3417646,16.2533298 14.4336777,16.213567 14.5018406,16.1426964 L17.033844,13.5113267 C17.1036694,13.4388254 17.1428571,13.3398574 17.1428571,13.2366247 C17.1428571,13.1333919 17.1036694,13.0344239 17.0338439,12.9619226 Z M7.14166964,0.770670945 L10.0011875,0.770670945 L10.0011875,2.5138373 L7.14166964,2.5138373 L7.14166964,0.770670945 Z M3.04619403,7.77657661 L0.884930512,5.53054243 L3.04619403,3.28450824 L6.41206508,3.28450824 L7.14166964,3.28450824 L10.0011875,3.28450824 L10.7307921,3.28450824 L14.8540553,3.28450824 L14.8540553,7.77657661 L10.730792,7.77657661 L10.0011875,7.77657661 L7.14166964,7.77657661 L6.41206508,7.77657661 L3.04619403,7.77657661 L3.04619403,7.77657661 Z M10.0011875,8.54724755 L10.0011875,10.2199196 L7.14166964,10.2199196 L7.14166964,8.54724755 L10.0011875,8.54724755 L10.0011875,8.54724755 Z M14.0966631,15.4826589 L10.730792,15.4826589 L10.0011875,15.4826589 L7.14166964,15.4826589 L6.41206508,15.4826589 L2.2888018,15.4826589 L2.2888018,10.9905905 L6.41206508,10.9905905 L7.14166964,10.9905905 L10.0011875,10.9905905 L10.7307921,10.9905905 L14.0966631,10.9905905 L16.2579266,13.2366247 L14.0966631,15.4826589 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R3-Web-App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R3-WebApp---Story-Review-(Static)",
    transform: "translate(-366.000000, -347.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(342.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tag-Bank",
    transform: "translate(24.000000, 93.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web-App-Icon/-Creativity-Copy-11",
    transform: "translate(0.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color",
    transform: "translate(6.428571, 5.357143)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#8688A1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.428571, -5.357143)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecisionmaking);
export default __webpack_public_path__ + "static/media/Decisionmaking.4386dbd23e78d8deacbaafa8281a5bfb.svg";
export { ForwardRef as ReactComponent };